import API from "../AxiosClient";
import ErrorHelper from "../../helpers/ErrorHelper";
import TokenDAO from "../../DAO/TokenDAO";

export default class NotificacaoService {

	static async notificacoes(empresaPk, colaboradorPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const prazoResponse = await API.get(`/empresa/${empresaPk}/colaborador/${colaboradorPk}/notificacao/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return prazoResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async editarNotificacao(empresaPk, colaboradorPk, notificacaoPk, notificacao) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.put(`/empresa/${empresaPk}/colaborador/${colaboradorPk}/notificacao/${notificacaoPk}/`, notificacao, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}
}
